<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';
import L from 'leaflet';

const props = defineProps<{
  map: any; // Leaflet Map instance
}>();

let trafficLayer: any = null;

const addTrafficLayer = () => {
    if (!props.map) {
        console.warn('[TrafficLayer] Missing map');
        return;
    }

    const url = `/proxy/tomtom-tiles/flow/relative/{z}/{x}/{y}.png`;

    trafficLayer = L.tileLayer(url, {
        tileSize: 512,
        zoomOffset: -1,
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.tomtom.com/">TomTom</a>',
        opacity: 0.7,
        zIndex: 200
    });

    trafficLayer.addTo(props.map);
    console.log('[TrafficLayer] Traffic layer added');
};

onMounted(() => {
    addTrafficLayer();
});

onBeforeUnmount(() => {
    if (trafficLayer) {
        trafficLayer.remove();
        trafficLayer = null;
        console.log('[TrafficLayer] Traffic layer removed');
    }
});
</script>
